module.exports = __webpack_public_path__ + "static/media/12client.12e994fc.png";